import { useState } from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { Reveal } from "@/components/Reveal";
import { IMAGES, PROJECTS } from "@/lib/site";

const FILTERS = ["All", ...new Set(PROJECTS.map((p) => p.cat))];
const spans = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-4", "md:col-span-4", "md:col-span-4", "md:col-span-12"];

export default function Projects() {
  const [filter, setFilter] = useState("All");
  const list = filter === "All" ? PROJECTS : PROJECTS.filter((p) => p.cat === filter);

  return (
    <main data-testid="projects-page">
      <SEO
        title="Projects — Kitchens, Bathrooms & Custom Interiors GTA | Hive Interiors"
        description="Explore Hive Interiors project styles: modern and traditional kitchens, bathroom renovations, custom vanities, closets, built-ins and full home interiors across the GTA."
      />
      <PageHero
        image={IMAGES.projectsHero}
        overline="Our Work"
        title="Featured"
        italic="Projects"
        sub="A look at the spaces we design and build — kitchens, bathrooms, vanities, closets, built-ins, and complete home interiors."
        alt="Featured interior renovation project by Hive Interiors"
      />

      <section className="py-24 md:py-36">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="flex flex-wrap gap-3 mb-14" data-testid="projects-filters">
              {FILTERS.map((f) => (
                <button
                  key={f}
                  data-testid={`projects-filter-${f.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={() => setFilter(f)}
                  className={`px-5 py-2.5 text-[11px] uppercase tracking-[0.18em] font-bold border transition-colors duration-300 ${
                    filter === f
                      ? "bg-primary text-primary-foreground border-primary"
                      : "border-border text-muted-foreground hover:border-primary hover:text-primary"
                  }`}
                >
                  {f}
                </button>
              ))}
            </div>
          </Reveal>

          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
            {list.map((p, i) => (
              <Reveal key={p.title} delay={(i % 4) * 0.08} className={spans[PROJECTS.indexOf(p) % spans.length]}>
                <div data-testid={`projects-tile-${p.title.toLowerCase().replace(/\s+/g, "-")}`} className="group relative overflow-hidden aspect-[16/10]">
                  <img
                    src={p.img}
                    alt={p.alt}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="absolute bottom-0 left-0 p-6">
                    <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-primary">{p.cat}</p>
                    <h3 className="font-heading text-2xl md:text-3xl tracking-tight text-white mt-1">{p.title}</h3>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Imagine Your Home"
        italic="in This Gallery"
        text="Every project starts with a conversation. Tell us about your space and let's design something beautiful together."
      />
    </main>
  );
}
